import React from 'react';
import { useArticles } from '../contexts/ArticleContext';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  const { getAllArticles } = useArticles();
  const articles = getAllArticles();

  // 获取当前年份
  const currentYear = new Date().getFullYear();

  return (
    <div className="home">
      <div className="home-header">
        <h1>欢迎来到我的技术博客</h1>
        <p className="home-subtitle">分享前端开发、后端技术和编程心得</p>
      </div>
      
      {articles.length > 0 && (
        <div className="featured-article">
          <div className="featured-content">
            <span className="featured-badge">最新文章</span>
            <h2 className="featured-title">
              <Link to={`/article/${articles[0].id}`}>{articles[0].title}</Link>
            </h2>
            <p className="featured-excerpt">{articles[0].excerpt}</p>
            <div className="featured-meta">
              <span className="author">作者：{articles[0].author}</span>
              <span className="date">{articles[0].date}</span>
              <span className="read-time">阅读时间：{articles[0].readTime}</span>
            </div>
          </div>
        </div>
      )}
      
      <div className="recent-articles">
        <h2 className="section-title">最新文章</h2>
        {articles.length === 0 ? (
          <div className="no-articles">
            <p>暂无文章，快去写一篇吧！</p>
            <Link to="/write" className="write-link">开始写作</Link>
          </div>
        ) : (
          <div className="articles-grid">
            {articles.map(article => (
              <div key={article.id} className="article-card">
                <div className="article-header">
                  <h3 className="article-title">
                    <Link to={`/article/${article.id}`}>{article.title}</Link>
                  </h3>
                  <div className="article-meta">
                    <span className="article-date">{article.date}</span>
                    <span className="article-read-time">{article.readTime}</span>
                  </div>
                </div>
                <p className="article-excerpt">{article.excerpt}</p>
                <div className="article-footer">
                  <span className="article-author">{article.author}</span>
                  <div className="article-tags">
                    {article.tags.map(tag => (
                      <span key={tag} className="tag">{tag}</span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      
      <div className="home-stats">
        <div className="stat-item">
          <div className="stat-number">{articles.length}</div>
          <div className="stat-label">文章总数</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">{articles.reduce((sum, article) => sum + parseInt(article.readTime), 0)}</div>
          <div className="stat-label">累计阅读分钟</div>
        </div>
        <div className="stat-item">
          <div className="stat-number">2023</div>
          <div className="stat-label">开始年份</div>
        </div>
      </div>
      
      {/* 添加 copyright 部分 */}
      <div className="home-copyright">
        <div className="copyright-content">
          <p className="copyright-text">
            © {currentYear} 我的技术博客. 保留所有权利.
          </p>
          <p className="copyright-subtext">
            本博客内容采用知识共享署名-非商业性使用-相同方式共享 4.0 国际许可协议进行许可
          </p>
          <div className="copyright-links">
            <Link to="/privacy">隐私政策</Link>
            <span className="divider">|</span>
            <Link to="/terms">服务条款</Link>
            <span className="divider">|</span>
            <Link to="/about">关于我们</Link>
            <span className="divider">|</span>
            <Link to="/contact">联系我们</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;